import React, { useState } from 'react'
import CLFooter from 'syf-component-library/ui/patterns/Footer'
import { clientInfo } from 'configureBrand'
import formatFooterLinks from './formatFooterLinks'
import { FooterProps } from './typings'
import LostUserLocatorModal from './LostUserLocatorModal'

const Footer = ({ currentLanguage, isCplRoute }: FooterProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const closeModal = () => {
    setIsOpen(false)
  }

  return (
    <>
      <LostUserLocatorModal isOpen={isOpen} closeModal={closeModal} />
      <CLFooter
        data-test="footer"
        body={clientInfo.footerContent[currentLanguage]}
        linkList={formatFooterLinks(currentLanguage)}
        showCobrowse={!isCplRoute}
        onUserLocatorClick={() => setIsOpen(state => !state)}
        userLocatorAnalyticsProps={{
          className: 'ensightencustomevent',
          dataTitle: 'footer',
          dataReason: 'lost user locator'
        }}
      />
    </>
  )
}

export default Footer
